/* eslint-env jest */
import { parseItem, collapseItems } from './packageItems';

describe('parseItem', () => {
  it('parses a "(N) Label" row', () => {
    expect(parseItem('(3) 5x7')).toEqual({ count: 3, label: '5x7' });
  });

  it('doubles "(1) Magnets" to (2) so the card shows the customer-facing count', () => {
    expect(parseItem('(1) Magnets')).toEqual({ count: 2, label: 'Magnets' });
  });

  it('also doubles the singular "(1) Magnet"', () => {
    expect(parseItem('(1) Magnet')).toEqual({ count: 2, label: 'Magnet' });
  });

  it('is case-insensitive on the magnets rule', () => {
    expect(parseItem('(1) magnets')).toEqual({ count: 2, label: 'magnets' });
    expect(parseItem('(1) MAGNETS')).toEqual({ count: 2, label: 'MAGNETS' });
  });

  it('leaves an explicit "(2) Magnets" alone (admin already asked for two sheets)', () => {
    expect(parseItem('(2) Magnets')).toEqual({ count: 2, label: 'Magnets' });
  });

  it('leaves other "(1) X" rows unchanged', () => {
    expect(parseItem('(1) 8x10')).toEqual({ count: 1, label: '8x10' });
    expect(parseItem('(1) High-Resolution Download')).toEqual({ count: 1, label: 'High-Resolution Download' });
  });

  it('does NOT match a label that merely contains "magnet" (e.g. "Magnet Frame")', () => {
    expect(parseItem('(1) Magnet Frame')).toEqual({ count: 1, label: 'Magnet Frame' });
  });

  it('treats a free-text row as count 1', () => {
    expect(parseItem('Free-text note')).toEqual({ count: 1, label: 'Free-text note' });
  });
});

describe('collapseItems', () => {
  it('sums repeats and pluralizes when the total is >1', () => {
    expect(collapseItems([
      '(1) High-Resolution Download',
      '(1) High-Resolution Download',
      '(1) High-Resolution Download',
    ])).toEqual(['(3) High-Resolution Downloads']);
  });

  it('merges singular + plural rows under the plural label', () => {
    expect(collapseItems(['(1) Download', '(1) Downloads'])).toEqual(['(2) Downloads']);
  });

  it('does not pluralize size strings that end in a digit', () => {
    expect(collapseItems(['(2) 8x10', '(1) 8x10'])).toEqual(['(3) 8x10']);
  });

  it('applies the magnets-doubling rule before collapsing', () => {
    // Two sheets written as two "(1) Magnets" lines -> 2+2 = 4 individual magnets.
    expect(collapseItems(['(1) Magnets', '(1) Magnets'])).toEqual(['(4) Magnets']);
  });

  it('preserves order of first appearance', () => {
    expect(collapseItems(['(1) 5x7', '(2) 8x10', '(1) 5x7']))
      .toEqual(['(2) 5x7', '(2) 8x10']);
  });
});
